export const DEEP_LINK_URL = "https://sharemarket.onelink.me/uMHZ/01yst4d0";

export const LOGIN_BUTTON_WEB_TITLE = "Login";
export const LOGIN_BUTTON_MOBILE_TITLE = "Trade on App";
